import React, { useEffect } from 'react';

const CreditBox = () => (
  <div className="w-6 h-6 rounded border-2 border-primary mx-auto" />
);

const SkillSheetPreview = ({ template, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);
  if (!template) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className="relative bg-white dark:bg-bg rounded-xl shadow-lg p-6 w-full max-w-xl border border-primary max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        <button
          className="absolute top-2 right-2 text-xl text-primary hover:text-red-500 p-1 rounded-full"
          onClick={onClose}
          aria-label="Close Preview"
        >
          ×
        </button>
        <h2 className="text-lg font-bold mb-2 text-primary">{template.name || '(Untitled)'}</h2>
        <div className="mb-4 text-text/70 text-sm">{template.description}</div>
        <table className="w-full table-auto border border-gray-400 rounded-xl bg-table shadow mb-2 text-sm">
          <thead>
            <tr className="bg-gradient-to-r from-primary/80 to-secondary/80 text-bg">
              <th className="p-2">Objective</th>
              <th className="p-2">Instructor Notes</th>
              <th className="p-2 text-center">Full</th>
              <th className="p-2 text-center">Half</th>
              <th className="p-2 text-center">None</th>
            </tr>
          </thead>
          <tbody>
            {template.rows && template.rows.length > 0 ? template.rows.map((row, idx) => (
              <tr key={idx} className={row.critical ? 'bg-red-50' : ''}>
                <td className={`p-2 align-middle${row.critical ? ' text-red-700 font-bold' : ''}`}>{row.objective}</td>
                <td className="p-2 align-middle text-xs">{row.notes}</td>
                <td className="p-2 align-middle text-center"><CreditBox /></td>
                <td className="p-2 align-middle text-center"><CreditBox /></td>
                <td className="p-2 align-middle text-center"><CreditBox /></td>
              </tr>
            )) : (
              <tr><td colSpan={5} className="p-2 text-center text-text/60">No rows defined.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SkillSheetPreview;
